package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.Languages
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.ui.AppPreferenceDispatcherContext
import com.macrofocus.eflux.ui.BookmarksMenuComponent
import com.macrofocus.eflux.ui.LanguagesButton
import com.macrofocus.eflux.ui.PaletteType
import com.macrofocus.eflux.ui.mui.themes.Themes
import com.macrofocus.eflux.ui.mui.themes.useSetTheme
import i18next.invoke
import i18next.useTranslation
import js.objects.unsafeJso
import mui.material.*
import mui.material.styles.Palette
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.component.CPComponent
import react.FC
import react.Props
import react.ReactNode
import react.use
import web.cssom.Position
import web.cssom.px

class SettingsPerspective(private val dataLoader: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        var theme = useTheme<Theme>()
        val useSetTheme = useSetTheme()
        val (t, _) = useTranslation()
        val appPreference = use(AppPreferenceDispatcherContext)!!
//        val (appPreferenceState, setAppPreferenceState) = useState(BrowserAppPreference.State(appPreference))
        val themeType = appPreference.themeType

        fun toggleTheme() {
//            val type = if (appPreference.themeType == PaletteType.light)
//                PaletteType.dark
//            else
//                PaletteType.light
//            println("THEME: $themeType, ${theme.palette.mode} -> $type")
            val mode = theme.palette.unsafeCast<Palette>().mode
            val light = mode == PaletteMode.light
            println("THEME: $theme, $mode")
////            setAppPreferenceState(appPreferenceState.copy(themeType = type)
////            appPreference.setThemeType(type)
//            theme = if (type == PaletteType.light) createTheme(PaletteType.light) else createTheme(PaletteType.dark)
            if(light) {
                useSetTheme(Themes.DarkDiviso)
            } else {
                useSetTheme(Themes.LightDiviso)
            }
        }

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
//                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            BookmarksMenuComponent {
                this.dataLoader = dataLoader
                this.setLocalShiftValue = setLocalShiftValue
            }

            LanguagesButton {
                languages = Languages.values().toList()
            }

            mui.material.Tooltip {
                title =
                    ReactNode(t("appBar.${if (themeType == PaletteType.light) "darkTheme" else "lightTheme"}"))

                IconButton {
                    color = IconButtonColor.inherit
                    edge = IconButtonEdge.end
                    onClick = { toggleTheme() }

                    Icon { +"brightness_${if (themeType == PaletteType.light) "4" else "7"}_icon" }
                }
            }
        }
    }

}